import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/heider/Header";
import Hero from "./components/heider/Hero";
import Intro from "./components/heider/Intro";
import StatsCounter from "./components/heider/StatsCounter";
import Pillars from "./components/heider/Pillars";
import SocialBrand from "./components/heider/SocialBrand";
import CameraReveal from "./components/heider/CameraReveal";
import Advertising from "./components/heider/Advertising";
import RecentlySold from "./components/heider/RecentlySold";
import FeaturedListings from "./components/heider/FeaturedListings";
import Boundaries from "./components/heider/Boundaries";
import Developers from "./components/heider/Developers";
import MediaLogos from "./components/heider/MediaLogos";
import Testimonials from "./components/heider/Testimonials";
import ContactForm from "./components/heider/ContactForm";
import Footer from "./components/heider/Footer";
import BuyPage from "./pages/BuyPage";
import SellPage from "./pages/SellPage";
import TeamPage from "./pages/TeamPage";
import DevelopersPage from "./pages/DevelopersPage";
import AgentProfile from "./pages/AgentProfile";
import BlogPage from "./pages/BlogPage";
import BlogPost from "./pages/BlogPost";
import BrokerOpens from "./pages/BrokerOpens";
import Sitemap from "./pages/Sitemap";
import LeadershipPage from "./pages/LeadershipPage";
import PartnersPage from "./pages/PartnersPage";
import JoinPage from "./pages/JoinPage";
import MediaPage from "./pages/MediaPage";
import useReveal from "./hooks/useReveal";
import { Toaster } from "./components/ui/toaster";
import ChatWidget from "./components/heider/ChatWidget";

const Home = () => {
  useReveal();
  return (
    <div className="page-in">
      <Hero />
      <Intro />
      <StatsCounter />
      <Pillars />
      <SocialBrand />
      <CameraReveal />
      <Advertising />
      <RecentlySold />
      <FeaturedListings />
      <Boundaries />
      <Developers />
      <MediaLogos />
      <Testimonials />
      <ContactForm />
      <Footer />
    </div>
  );
};

const ScrollToHash = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, [location]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/buy" element={<BuyPage />} />
          <Route path="/sell" element={<SellPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/team/:slug" element={<AgentProfile />} />
          <Route path="/developers" element={<DevelopersPage />} />
          <Route path="/broker-opens" element={<BrokerOpens />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/leadership" element={<LeadershipPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/join" element={<JoinPage />} />
          <Route path="/media" element={<MediaPage />} />
        </Routes>
        <Toaster />
        <ChatWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
